<template>
  <div id="app">
    <transition name="slide">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {mapGetters} from 'vuex';
  import ClickOutside from 'vue-click-outside';

  export default {
    name: 'App',
    components: {},
    data: function () {
      return {
      }
    },
    props: [],
    mounted: function () {
    },
    updated() {
    },
    watch: {
    },
    methods: {

    },
    computed: {
      ...mapState({
        env: 'env',
      }),

      ...mapGetters({
        isLoading: 'isLoading',
      }),
    },
    directives: {
      ClickOutside
    }
  }
</script>

<style lang="scss">
  body {
    background-color: #d0eeff;
  }
</style>
